import React, { useState, useCallback, useContext, useEffect } from 'react'
import { getBEMCls } from '@/utils/classname'

import './tab.scss'
import { __RouterContext, RouteComponentProps } from 'react-router'
import Auth from '@/views/main/components/auth/auth'

export interface TabItem {
    id: number
    name: string
    route?: string
    activeRoutes?: string[]
    activeRoutePrefixes?: string[]
    activeColor?: string
    perssion?: number
    count?: number
}

interface TabProps {
    tabList: TabItem[]
    activeColor?: string
    onClick?: (item: TabItem) => void
    activeId?: number
    defaultActiveId?: number
    itemWidth?: number
    activeItemAppend?: React.ReactNode
}

const Tab: React.FC<TabProps> = props => {
    const getCls = (el?: string, moder?: string) => getBEMCls('tab', el, moder)
    const router = useContext(__RouterContext) as RouteComponentProps | undefined
    const history = router && router.history
    const historyPathname = history?.location?.pathname

    const itemWidth = props.itemWidth || 96
    const lineOffset = (itemWidth - 64) / 2
    const [activeId, setActiceId] = useState<number>(props.defaultActiveId || props.tabList[0]?.id || 0)
    const activeIndex = Math.max(
        props.tabList.findIndex(item => item.id === activeId),
        0,
    )
    const handleTab = useCallback(item => {
        setActiceId(item.id)
        item.route && history && history.replace(item.route)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (props.activeId !== undefined) {
            setActiceId(props.activeId)
        }
    }, [props.activeId])

    useEffect(() => {
        if (props.activeId !== undefined) return
        if (!historyPathname) {
            setActiceId(props.defaultActiveId || props.tabList[0]?.id || 0)

            return
        }

        const path = historyPathname
        const macthId = props.tabList.filter(list => {
            if (list.route === path || list.activeRoutes?.includes(path)) return true

            return list.activeRoutePrefixes?.some(route => path === route || path.indexOf(`${route}/`) === 0)
        })[0]?.id

        setActiceId(macthId === undefined ? props.defaultActiveId || props.tabList[0]?.id || 0 : macthId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [historyPathname, props.activeId])

    return (
        <div className={getCls()}>
            {props.tabList.map(item => (
                <React.Fragment key={`tab-${item.id}`}>
                    <Auth
                        perssion={item.perssion}
                        onClick={() => {
                            handleTab(item)
                            props.onClick && props.onClick(item)
                        }}
                    >
                        <div
                            className={`${item.id === activeId ? getCls('item') : getCls('item', 'active')}`}
                            style={
                                item.activeColor || props.itemWidth
                                    ? {
                                          color: item.activeColor,
                                          width: props.itemWidth,
                                      }
                                    : undefined
                            }
                        >
                            {!!item.count && <span className={getCls('badge')}>{item.count}</span>}
                            {item.name}
                        </div>
                    </Auth>
                    {item.id === activeId ? props.activeItemAppend : null}
                </React.Fragment>
            ))}
            <div
                className={getCls('line')}
                style={{
                    left: `${lineOffset + itemWidth * activeIndex}px`,
                    backgroundColor: props.activeColor ? props.activeColor : void 0,
                }}
            />
        </div>
    )
}

export default Tab
